const G = "g";
const PG = "pg";
const ADULT = "+15";
const R = "r";
export function parentalControlValues(value) {
  switch (value) {
    case "18":
      return R;
    case "15":
      return ADULT;
    case "7":
      return PG;
    case "1":
      return G;
    default:
      return "";
  }
}
